// extracted by mini-css-extract-plugin
export default {"textarea":"style-module__textarea___NGBx3"};